import moment from 'moment';

// FailedAppointmentSchema declares `appoinmentDate` as Yup.string(), so by the
// time react-hook-form hands the values to onSubmit the DateTimePicker's Date
// has been cast to its toString() form. Never call Date methods on it directly.
export const toDate = (value) => (value instanceof Date ? value : new Date(value));

// explicit = a selected appointment (OpenUnAttendedPopup) → the API takes ISO UTC;
// otherwise the legacy wizard format the backend parses as Europe/London.
export const failedAppointmentDatetime = (value, { explicit }) => {
    if (explicit) {
        const date = toDate(value);
        if (Number.isNaN(date.getTime())) throw new Error('Select a valid appointment date.');
        return date.toISOString();
    }
    return `${moment(value).format('DD-MM-YYYY HH:mm:ss')}.0Z`;
};
